import { AccountPermission } from 'modules/permissions/constants';
import { GuardAccountPermission } from 'modules/account/components/GuardAccountPermission';
import { StatusTransitionDialog } from 'modules/layout/components/StatusTransitionDialog';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';

export const StatusTransitionDialogContainer = () => {
  const { isEnterprise, loaded: accountStatusLoaded } = useAccountStatus();

  if (!accountStatusLoaded || isEnterprise) {
    return null;
  }

  return (
    <GuardAccountPermission permission={AccountPermission.Billing}>
      <StatusTransitionDialog />
    </GuardAccountPermission>
  );
};
